import configs from 'configs';
import { useEffect, useRef } from 'react';

export const useGoogleOneTapAuth = (handleAuthCallback, options = {}) => {
  const { disabled = false } = options;
  const isInitialized = useRef(false);
  const disabledRef = useRef(disabled);

  useEffect(() => {
    disabledRef.current = disabled;
  }, [disabled]);

  // Cancel any active prompts if present to not conflict with current
  useEffect(() => () => window.google?.accounts?.id.cancel(), []);

  useEffect(() => {
    const { google } = window;
    if (!google?.accounts?.id) return;

    if (disabled) {
      // Hide One Tap while disabled
      google.accounts.id.cancel();
      return;
    }

    if (!isInitialized.current) {
      google.accounts.id.initialize({
        client_id: configs.externalAuth.google.appId,
        callback: (response) => {
          if (disabledRef.current) {
            // Ignore callbacks while disabled to prevent race conditions
            return;
          }
          handleAuthCallback(response.credential);
        },
        cancel_on_tap_outside: false,
        prompt_parent_id: 'g_id_onload',
      });
      isInitialized.current = true;
    }

    // Showing UI on the screen
    google.accounts.id.prompt();
  }, [disabled, handleAuthCallback]);

  return true;
};
